import React, { useState } from 'react';
import '../styles/common.css';
import './ContactPage.css';

import api from '../api'; // Import configured axios instance

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null); // 'success' | 'error'
  const [errorMessage, setErrorMessage] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);
    setErrorMessage('');

    try {
      const response = await api.post('/contact', formData);

      setSubmitStatus('success');
      setFormData({
        name: '',
        phone: '',
        email: '',
        subject: '',
        message: ''
      });

      // Clear success message after 5 seconds
      setTimeout(() => setSubmitStatus(null), 5000);

    } catch (error) {
      console.error('Contact submit error:', error);
      setSubmitStatus('error');
      setErrorMessage(error.response?.data?.message || 'Failed to submit. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="page-container">
      <div className="page-header contact-header">
        <h1>Contact MAB Jewels (Manoj Abhushan Bhandar, Rajasthan)</h1>
        <p>Looking for a trusted gold jewellery shop near you in Rajasthan? Visit MAB Jewels in Jodhpur for BIS hallmark gold jewellery and wedding collections.</p>
      </div>

      <div className="contact-content">
        {/* Contact Information - Trust Anchors */}
        <div className="contact-info-section">
          <h3>MAB Jewels Legacy</h3>
          <p className="legacy-text">Serving Rajasthan with purity and trust since 1994. <br />Managed by <strong>JP Soni</strong>.</p>

          <div className="contact-methods">
            <div className="contact-method">
              <div className="method-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
              </div>
              <div className="method-details">
                <h4>Visit Our Store</h4>
                <p>MAB Jewels, Main Market</p>
                <p>Rajasthan, India - 306301</p>
                <span className="trust-link">Start Directions →</span>
              </div>
            </div>

            <div className="contact-method">
              <div className="method-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
              </div>
              <div className="method-details">
                <h4>Call Us Directly</h4>
                <p>+91 9414817620</p>
                <p className="highlight-text">trusted by 5,000+ families</p>
              </div>
            </div>

            <div className="contact-method">
              <div className="method-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
              </div>
              <div className="method-details">
                <h4>Email Support</h4>
                <p>mabjewels.store@gmail.com</p>
              </div>
            </div>
          </div>

          {/* Trust Badges Simple */}
          <div className="contact-trust-badges">
            <span className="badge-text">🏆 BIS Hallmarked</span>
            <span className="badge-text">💎 Certified Purity</span>
          </div>

        </div>

        {/* Contact Form - Guided */}
        <div className="contact-form-section">
          <h3>Request a Call Back</h3>
          <p>Leave your details, and JP Soni or our senior staff will call you.</p>

          {submitStatus === 'success' && (
            <div className="success-message">
              Request received! We will call you shortly.
            </div>
          )}

          {submitStatus === 'error' && (
            <div className="error-message" style={{ color: 'red', textAlign: 'center', marginBottom: '1rem', padding: '10px', background: '#ffe6e6', borderRadius: '4px' }}>
              {errorMessage}
            </div>
          )}

          <form onSubmit={handleSubmit} className="contact-form">
            <div className="form-grid">
              <div className="form-group">
                <label htmlFor="name">Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                  className="form-control"
                  placeholder="Your Name"
                />
              </div>

              <div className="form-group">
                <label htmlFor="phone">Phone Number *</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  required
                  className="form-control"
                  placeholder="Your Mobile Number"
                />
              </div>

              <div className="form-group full-width">
                <label htmlFor="subject">How can we help? *</label>
                <select
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleInputChange}
                  required
                  className="form-select"
                >
                  <option value="">Select an option...</option>
                  <option value="gold_rate">Today's Gold Rate Query</option>
                  <option value="jewellery_purchase">Latest Jewellery Designs</option>
                  <option value="custom_order">Custom Order / Repair</option>
                  <option value="store_visit">Plan a Store Visit</option>
                  <option value="other">Other Inquiry</option>
                </select>
              </div>

              <div className="form-group full-width">
                <label htmlFor="message">Message (Optional)</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  className="form-control"
                  placeholder="Any specific requirement?"
                  rows="3"
                />
              </div>
            </div>

            <div className="form-actions">
              <button
                type="submit"
                disabled={isSubmitting}
                className="btn-primary"
              >
                {isSubmitting ? 'Sending...' : 'Request Call Back'}
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* Styled Divider */}
      <div className="section-divider">
        <span>—— OR VISIT US IN STORE ——</span>
      </div>

      {/* Map Section - Real Embed */}
      <div className="map-section">
        <div className="map-container-real">
          <iframe
            src="https://www.google.com/maps?q=26.36566162675963,73.98881391177571&hl=en&z=17&output=embed"
            width="100%"
            height="400"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Manoj Abhushan Bhandar Location"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
